import { fetchApiData, fetchApiDataV2, updateApiDataV2, fetchPublicApi ,commentImageUpload,commentGifUpload} from "../../utils/utils";

export const getVideoDetails = async (id,appInfo,showId) =>{
    const api =`video/details/${id}`
    const params = showId ? { show_id: showId } : null
    return await fetchApiDataV2(appInfo,api,params)
}

export const getShowDetails=async (appInfo,showId)=>{
    const api=`show/details/${showId}`
    return await fetchApiDataV2(appInfo,api)
}
export const getSimilarVideos=async (appInfo,showId)=>{
    const api=`show/similar/${showId}`
    return await fetchApiDataV2(appInfo,api)
}
export const commentImageUploadThumbnail = async (data,appInfo) =>{
    const api =`comments/image`
  
    return await commentImageUpload(data,appInfo,api)
  }
  export const commentGifUploadThumbnail = async (data,appInfo) =>{
    const api =`comments/gif`
  
    return await commentGifUpload(data,appInfo,api)
  }
